import {createContext} from 'react';
import {AutomationNode} from 'crqlar-react-common/dist/models/automation/automation';

export interface ManualTriggerRun {
    onRequestRun: () => void;
    isRunning: boolean;
    disabled: boolean;
    disabledReason?: string;
    hasUnsavedChanges: boolean;
}

export interface NodeActions {
    readOnly: boolean;
    /** Opens the node's dialog, read-only for a viewer. */
    onEdit: (nodeData: AutomationNode) => void;
    onAppendClick: (nodeId: string, sourceHandle: string | null, anchorEl: HTMLElement) => void;
    /** The handle whose picker is open right now. */
    activeAppend: {nodeId: string; sourceHandle: string | null} | null;
    /** The editor owns the run's confirmation, saving and queuing. */
    getManualRun: (nodeId: string) => ManualTriggerRun;
}

export const NodeActionsContext = createContext<NodeActions | null>(null);
